import { render } from "./RatioChart.vue?vue&type=template&id=87b5f162"
import script from "./RatioChart.vue?vue&type=script&lang=js"
export * from "./RatioChart.vue?vue&type=script&lang=js"

import "./RatioChart.vue?vue&type=style&index=0&id=87b5f162&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__